<template>
    <div class="correct-exam2">
        <p class="return pointer no-wrap font-size16" @click="returnup">返回</p>
        <el-form class="xy-between p-48" inline>
            <div>
                <el-form-item label="用户组">
                    <user-group-selector
                        v-model="query.organLevelId"
                        @change="loadData(true)"
                    />
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="query.examState" placeholder="批阅状态" clearable
                        @change="loadData(true)"
                    >
                        <el-option label="未阅" value="2"/>
                        <el-option label="已阅" value="4"/>
                    </el-select>
                </el-form-item>
            </div>
            <el-form-item>
                <div class="xy-center">
                    <el-input placeholder="请输入关键字检索" v-model="query.keyword"></el-input>
                    <el-button type="primary" class="ml-10" @click="loadData(true)">检索</el-button>
                </div>
            </el-form-item>
        </el-form>
        <div class="ph-48" v-loading="loading">
            <el-table :data="list">
                <el-table-column label="考试名称" prop="ExamName" width="200"/>
                <el-table-column label="用户名" prop="UserName" width="150"/>
                <el-table-column label="真实姓名" prop="RealName" width="80"/>
                <el-table-column label="所属用户组" prop="OrganLevelName" width="100" :formatter="defaultVal"/>
                <el-table-column label="考试次数" prop="ExamNum" width="80"/>
                <el-table-column label="交卷时间" prop="EndTime" width="150" :formatter="timeNoSec"/>
                <el-table-column label="考试成绩" prop="ExamScore" width="80"/>
                <el-table-column label="状态" width="100">
                    <template v-slot="scope">
                        <span v-if="parseInt(scope.row.ExamState) === 2">未阅</span>
                        <span v-if="parseInt(scope.row.ExamState) === 4">已阅卷</span>
                    </template>
                </el-table-column>
                <el-table-column label="阅卷人" prop="MarkUser" width="100" :formatter="defaultVal"/>
                <el-table-column label="阅卷时间" prop="MarkingTime" width="150" :formatter="timeNoSec"/>
                <el-table-column fixed="right" label="操作" width="100">
                    <template v-slot="scope">
                        <el-button size="mini" type="primary" @click="startView(scope.row)">
                            {{parseInt(scope.row.ExamState) === 4 ? '答题明细' : '开始阅卷'}}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pv-16 xy-center">
            <el-pagination
                @current-change="loadData()"
                @size-change="loadData(true)"
                :current-page.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                hide-on-single-page
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { cleanNoneParam } from "@/utils";
import { MarkStudentList } from "@/api/manage";
import tableFormatter from "@/mixins/tableFormatter";
import UserGroupSelector from "@/components/manager/UserGroupSelector";

export default {
    name: "correct-exam2",
    components: { UserGroupSelector },
    mixins: [tableFormatter],
    data() {
        return {
            query: {
                organLevelId: "",
                examState: "",
                keyword: "",
                pageNo: 1,
                pageSize: 10
            },
            total: 0,
            list: [],
            loading: false
        }
    },
    created() {
        window.scrollTo(0, 0);
        this.loadData()
    },
    methods: {
        returnup() {
            this.$router.go(-1)
        },
        startView(row) {
            if (row.IsMarkAuthorize === false) {
                this.$message.error("您不是阅卷老师，暂时没有查看权限")
            } else {
                let query = {
                    joinDetailId: row.JoinDetailId,
                    examId: row.ExamId,
                    examName: row.ExamName
                }
                if (parseInt(row.ExamState) === 4) {
                    query.onlyView = "1"
                }
                let { href } = this.$router.resolve({
                    name: "gradingPaper",
                    query: query
                })
                window.open(href, "_blank")
            }
        },
        loadData(refresh) {
            if (refresh === true) {
                this.query.pageNo = 1
            }
            let query = cleanNoneParam(this.query)
            // query.examId = "c084b415dc60495b93441e33483510e2"
            query.examId = this.$route.query.id
            this.loading = true;
            MarkStudentList(query).then(({ data }) => {
                this.list = data.data
                this.total = data.count
            }).finally(() => {
                console.log("error")
                this.loading = false
            })
        }
    },
}
</script>

<style lang="less" scoped>
.correct-exam2{
    position: relative;
    .return{
        color: #969799;
        position: absolute;
        top: 0.05rem;
        left: 0.1rem;
    }
}
</style>
